export default __webpack_public_path__ + "static/media/levels-icon.d8eb0f55.svg";